import { find, propEq } from "ramda";
import { Maybe } from "true-myth";
import { IOption } from "components/shared/dropdown";

type IGracePeriodDropdownOption = IOption<number>;

const GRACE_PERIODS: IGracePeriodDropdownOption[] = [
  { id: "5 minutes", label: "5 minutes", meta: 300 },
  { id: "10 minutes", label: "10 minutes", meta: 600 },
  { id: "15 minutes", label: "15 minutes", meta: 900 },
  { id: "30 minutes", label: "30 minutes", meta: 1800 },
];

function getSelectedGracePeriodOption(
  gracePeriod: number
): IGracePeriodDropdownOption {
  const matchingOption = Maybe.of(
    find(propEq("meta", gracePeriod), GRACE_PERIODS)
  );
  return matchingOption.match({
    Just: (matchingGracePeriodOption) => matchingGracePeriodOption,
    Nothing: () => GRACE_PERIODS[0],
  });
}
export {
  IGracePeriodDropdownOption,
  GRACE_PERIODS,
  getSelectedGracePeriodOption,
};
